export const digIdSuccess = 'digIdSuccess';
export const digIdFailure = 'digIdFailure';
